<template>
  <v-container>
    <v-card id="dprCard" class="pa-0">
      <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t('vessel.DPRSignOff') }}</v-card-title>
      <v-data-table id="dprTable" :headers="headers" :items="items" :items-per-page="-1" disable-pagination  class="elevation-0">
        <template slot="item" slot-scope="props">
          <tr>
            <td style="text-align: left">{{ props.item.name }}</td>
            <td style="text-align: left">{{ props.item.position }}</td>
            <td style="text-align: left">{{ props.item.company }}</td>
            <td v-if="!!props.item.signature">
              <img :src="props.item.signature | signatureImg" style="width: 125px; height: 50px" />
            </td>
            <td style="text-align: center">
              <v-btn v-if="loggedInUser.id == props.item.userId" id="btnDel" color="primary" x-small fab outlined elevation="1" :disabled="isReadOnly" @click="deleteItemConfirm(props.item)">
                <v-icon small color="primary">mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="editedItem.name">
                    <template v-slot:label>{{ $t('vessel.columnName') }}</template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="editedItem.company">
                    <template v-slot:label>{{ $t('vessel.company') }}</template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="editedItem.position">
                    <template v-slot:label>{{ $t('vessel.position') }}</template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <img :src="editedItem.signature" v-if="editedItem.signature" style="width: 150px; height: 50px" />
                </v-col>
                <v-col cols="12">
                  <v-textarea auto-grow outlined v-model="editedItem.cliComment">
                    <template v-slot:label> {{ $t("comments.comments") }}</template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="primary" text @click="save">{{ $t('common.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFinalizeCloseDPR" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("signOff.tooltipFinalize") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span >{{ $t("dpr.senddprdlgmessage") }}</span>
                </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox class="ml-3" v-model="sendDprFlag">
                        <template v-slot:label>
                          {{ $t("dpr.senddprflag") }}
                        </template>
                      </v-checkbox>
                    </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeFinalizeCloseDPR">{{ $t('common.cancel') }}</v-btn>
            <v-btn color="primary" text @click="finalizeCloseDPR()">{{ $t('common.ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card-actions id="pCardAct">
        <v-tooltip bottom v-if="canSignByRoleCV && canSign && loggedInUserSignature != null">
          <template v-slot:activator="{ on, attrs }">
            <v-btn id="btnSigndpr" class="text-none ml-3" color="primary" v-bind="attrs" v-on="on" v-if="canSignByRoleCV && canSign && loggedInUserSignature != null && !isReadOnly" 
                @click="createItem()"> {{ $t("signOff.sign") }}<v-icon class="ml-2">mdi-plus</v-icon> </v-btn>
            <!-- <v-btn  color="primary" dark small left fab v-bind="attrs" v-on="on" @click="createItem()">
              <v-icon>mdi-plus</v-icon>
            </v-btn> -->
          </template>
          <span>{{$t('signOff.tooltipSign')}}</span>
        </v-tooltip>

        <v-tooltip bottom v-if="canSignByRolePA">
          <template v-slot:activator="{ on, attrs }">
            <v-btn id="btnSenddpr" class="text-none ml-3" dark color="green" v-bind="attrs" v-on="on" v-if="canSignByRolePA && !isReadOnly" :loading="emailSending"
                @click="finalizeCloseDPRDlg()"> {{ $t("signOff.sendDistList") }}<v-icon class="ml-2">mdi-email-multiple</v-icon> </v-btn>
            <!-- <v-btn  color="primary" dark small left fab v-bind="attrs" v-on="on" @click="createItem()">
              <v-icon>mdi-plus</v-icon>
            </v-btn> -->
          </template>
          <span>{{$t('signOff.tooltip.SendDistList')}}</span>
        </v-tooltip>

      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";
  var userRole = require("../../store/modules/user-role/user-roles");

  export default {
    data() {
      return {
        dialog: false,
        dialogFinalizeCloseDPR: false,
        headers: [
          {
            text: this.$t("vessel.columnName"),
            align: "left",
            sortable: true,
            value: "name",
            width: "15%",
          },
          {
            text: this.$t("vessel.position"),
            align: "left",
            value: "position",
          },
          {
            text: this.$t("vessel.company"),
            align: "left",
            value: "company",
          },
          {
            text: this.$t("vessel.signature"),
            align: "left",
            value: "signature",
          },
        ],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        currentMainDprId: null,
        currentPVId: null,
        isSendedDl: false,
        emailSending : false,
        sendDprFlag: true,
      };
    },
    computed: {
      ...mapGetters([
        "getLoggedInUser",
        "mv_dprData/getCurrentDprMainId",
        "mv_dprSignature/getDprSignatures",
        "mv_dprHeader/getDprFileId",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? this.$t("common.new") + " " + this.$t("vessel.DPRSignOff")
          : this.$t("common.edit") + " " + this.$t("vessel.DPRSignOff");
      },

      items() {
        return this["mv_dprSignature/getDprSignatures"];
      },

      loggedInUser() {
        return this.getLoggedInUser || {};
      },

      isReadOnly() {
        return this.isSendedDl;
      },

      loggedInUserSignature() {
        let sgn = this.loggedInUser.signature;
        if (!sgn || sgn.indexOf("data:image") !== -1) {
          return this.loggedInUser.signature;
        }

        return "data:image/png;base64," + this.loggedInUser.signature;
      },
      notSigned() {
        let items = this.items || [];
        var signed = false;
        for (var i = 0; i < items.length; i++) {
          if (items[i].userId == this.loggedInUser.id) {
            signed = true;
            break;
          }
        }
        return !signed;
      },

      isSigned() {
        return this.items.length > 0;
      },


      canSign() {
        let items = this.items || [];
        var signed = false;
        if (items.length > 0)
        {
          signed = true;
          for (var i = 0; i < items.length; i++) {
            if (items[i].userId == this.loggedInUser.id) {
              signed = false;
              break;
            }
          }
        } 
        this.$log.debug("canSign=", signed);
        return signed;
      },

      canSignByRoleCV() {
        var can = this.loggedInUser.roleName && userRole.CLIENT_VIEWER_ROLE == this.loggedInUser.roleName;
        this.$log.debug("canSignByRoleCV=", can);
        return can;
      },

      canSignByRolePA() {
        var can = this.loggedInUser.roleName && userRole.PROJECT_ADMIN_ROLE == this.loggedInUser.roleName;
        this.$log.debug("canSignByRolePA=", can);
        return can;
      },
},

    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this.refreshHeaderData();
      //this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId).then((dpr) => {
      //  this.isSendedDl = dpr.isSendedDl;
      //  this.refreshSignatures(dpr.dprFileId)
      //});
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    filters: {
      signatureImg(signature) {
        let sgn = signature;
        if (!sgn || sgn.indexOf("data:image") !== -1) {
          return signature;
        }

        return "data:image/png;base64," + signature;
      },
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_dprHeader/fetchDprHeader",
        "mv_dprSignature/fetchDprSignatures",
        "mv_dprSignature/createDprSignature",
        "mv_dprSignature/deleteDprSignature",
        "mv_dprHeader/finalizeCloseDpr"
      ]),
      resetEntity(item) {
        this.editedIndex = item ? this.items.indexOf(item) : -1;
        this.editedItem = Object.assign({}, item || this.defaultItem);
      },
      refreshHeaderData() {
        this.currentMainDprId = this.$route.params.dprMainId;
        this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId).then((dpr) => {
          this.isSendedDl = dpr.isSendedDL;
          this.refreshSignatures(dpr.dprFileId)
        });
      },
      refreshSignatures(dprFileId) {
        this.$log.debug(
          "refreh signatures for DPR file",
          dprFileId || this["mv_dprHeader/getDprFileId"]
        );

        this["mv_dprSignature/fetchDprSignatures"](
          dprFileId || this["mv_dprHeader/getDprFileId"]
        );
      },
      createItem() {
        this.resetEntity();
        let names = [this.loggedInUser.firstName, this.loggedInUser.lastName];
        this.editedItem.name = names.join(" ");
        this.editedItem.position = this.loggedInUser.position;
        this.editedItem.company = this.loggedInUser.company;
        this.editedItem.signature = this.loggedInUserSignature;
        this.dialog = true;
      },
      deleteItemConfirm(item) {
        //return item;
        this.resetEntity(item);
        var msg = "warning.delete";
        this.$confirm(this.$t(msg) + " entry ?", {
          buttonTrueText: this.$t("common.ok"),
          buttonFalseText: this.$t("common.cancel"),
          color: "warning",
          icon: "warning",
          title: this.$t("common.warning"),
          width: 350,
          property: "$confirm",
        }).then((res) => res && this["mv_dprSignature/deleteDprSignature"](this.editedItem).then(() => this.refreshHeaderData()));
      },
      close() {
        this.dialog = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      },

      closeFinalizeCloseDPR() {
        this.dialogFinalizeCloseDPR = false;
      },

      save() {
        if (!~this.editedIndex) {
          this.editedItem.userId = this.loggedInUser.id;
          this.editedItem.dprMainId = this.currentMainDprId;
          this.editedItem.dprFileId = this["mv_dprHeader/getDprFileId"];

          let sgn = this.editedItem.signature || "";
          this.editedItem.signature = sgn.replace(
            /data:image\/png;base64,/gi,
            ""
          );

          this["mv_dprSignature/createDprSignature"](this.editedItem).then(() =>
            this.refreshHeaderData()
          );
        }

        this.close();
      },

    finalizeCloseDPRDlg() {
      this.dialogFinalizeCloseDPR = true;
    },

    finalizeCloseDPR() {
      let signOffData = {
        finalizedUserId: this.loggedInUser.id,
        dprMainId: this.currentMainDprId,
        dprFileId: this["mv_dprHeader/getDprFileId"],
        sendToDL: this.sendDprFlag
      };
      this.$log.debug("signing-close off DPR", signOffData);

      this.emailSending = true;
      this["mv_dprHeader/finalizeCloseDpr"](signOffData).then(() => this.refreshHeaderData()).then(() => this.emailSending = false);

      this.closeFinalizeCloseDPR();
      /*
      this.$confirm(this.$t("dpr.senseddlWarning"), {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => {
        if (res) 
        {
          this.emailSending = true;
          this["mv_dprHeader/finalizeCloseDpr"](signOffData).then(() => this.refreshHeaderData()).then(() => this.emailSending = false);
        }
      })
      */
    },

    },
  };
</script>

<style>
  #dprsTable {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    height: auto;
  }
  #dprsTable header {
    font-weight: bold;
  }
  #dprsCard {
    width: auto;
  }
</style>